"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { useCurrentUser, useCurrentWorkspace } from "@/lib/auth/client";
import { Toaster } from "@/components/ui/sonner";
import posthog from "posthog-js";
import { ThemeProvider } from "./theme-provider";
export default function Providers(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const user = useCurrentUser();
  const workspace = useCurrentWorkspace();
  let t1;
  let t2;
  if ($[0] !== user) {
    t1 = () => {
      if (user) {
        Sentry.setUser(user);
        posthog.identify(user?.id?.toString(), user);
      } else {
        Sentry.setUser(null);
        posthog.reset();
      }
    };
    t2 = [user];
    $[0] = user;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== workspace?.client_code || $[4] !== workspace?.slug) {
    t3 = () => {
      const group = workspace?.slug ?? workspace?.client_code ?? "";
      if (group) {
        posthog.group("workspace", group);
      } else {
        posthog.resetGroups();
      }
    };
    $[3] = workspace?.client_code;
    $[4] = workspace?.slug;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== workspace) {
    t4 = [workspace];
    $[6] = workspace;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Toaster />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children) {
    t6 = <ThemeProvider><>{children}{t5}</></ThemeProvider>;
    $[9] = children;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}